module.exports = __webpack_public_path__ + "img/listlian.45f8aba0.png";